<template>
    <CommonItem
        :title="textField"
        :img-url="iconUrl"
        :show-checkbox="showCheckbox"
    />
</template>

<script>
import CommonItem from "@/components/OrgSelector/CommonItem"

export default {
    name: 'GroupItem',
    components: {
        CommonItem
    },
    props: ['textField', 'type', 'showCheckbox'],
    data() {
        return {
        }
    },
    computed: {
        iconUrl() {
            let iconName
            switch (this.type) {
                case -1:
                case 1:
                    iconName = 'sel-zuzhi.png'
                    break
                case 2:
                    iconName = 'sel-bumen.png'
                    break
                case 3:
                case 8:
                    iconName = 'sel-gangwei.png'
                    break
                case 4:
                    iconName = 'sel-zhiwei.png'
                    break
                case 5:
                case 9:
                case 10:
                    iconName = 'sel-qunzu.png'
                    break
                case 6:
                    iconName = 'sel-man.png'
                    break
                case 7:
                    iconName = 'sel-juese.png'
                    break
            }

            return require(`@/assets/image/org-selector/${iconName}`)
        },
    },
    methods: {},
    created() {
    }
}
</script>
